module.exports = __webpack_public_path__ + "img/historia5.f476f90b.jpg";